import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paginable'
})
export class PaginablePipe implements PipeTransform {
    transform(list: any[], paginable: boolean, pageNo: number, pageSize: number): any[] {
        if (!list) return [];
        if (paginable) {
            const startIdx = pageSize * (pageNo - 1);
            return list.slice(startIdx, startIdx + pageSize);
        }
        return list;
    }
}
